import React from 'react';

import styles from './ContactActionsLayout.css';

interface IContactActionsLayoutProps {
  brokerButton: React.ReactNode;
  phoneButton: React.ReactNode;
  electronicTradingButton: React.ReactNode;
  bookButton: React.ReactNode;
  chatButton: React.ReactNode;
  showMoreOffersLink: React.ReactNode;
}

export function ContactActionsLayout({
  brokerButton,
  phoneButton,
  electronicTradingButton,
  bookButton,
  chatButton,
  showMoreOffersLink,
}: IContactActionsLayoutProps) {
  return (
    <div className={styles['wrapper']}>
      {showMoreOffersLink}
      {brokerButton && <div className={styles['broker-button']}>{brokerButton}</div>}
      {phoneButton && <div className={styles['button']}>{phoneButton}</div>}
      {electronicTradingButton && <div className={styles['button']}>{electronicTradingButton}</div>}
      {chatButton && <div className={styles['button']}>{chatButton}</div>}
      {bookButton && <div className={styles['button']}>{bookButton}</div>}
    </div>
  );
}
